import { render, staticRenderFns } from "./BalanceInfo.vue?vue&type=template&id=31bf303e&scoped=true&"
import script from "./BalanceInfo.vue?vue&type=script&lang=js&"
export * from "./BalanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf303e",
  null
  
)

export default component.exports